export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_CARDS = 'GET_CARDS'
export const GET_CHARITY_DETAILS = 'GET_CHARITY_DETAILS'
export const GET_CHARITY_DETAILS_BY_ID = 'GET_CHARITY_DETAILS_BY_ID'
